import { render, staticRenderFns } from "./AppVehiclesNewSelectionDialog.vue?vue&type=template&id=2827c51c&scoped=true&"
import script from "./AppVehiclesNewSelectionDialog.vue?vue&type=script&lang=js&"
export * from "./AppVehiclesNewSelectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827c51c",
  null
  
)

export default component.exports